export class Exhibition {
	title;
	slug;
	image;
	type;
	gallery;
	videos;
	content;
	excerpt;
	color;
	textColor
	date_ini;
	date_end;
	info;
	products;
	news;
	
	constructor (object)
	{
		// Identifier
		this.id = object.id || null;
		this.slug = object.slug || null;
		this.title = object.title.rendered || null;
		
		//Content
		this.type = object.meta_box.settings.state || null;
		this.date_ini = object.meta_box.settings.date_ini || null;
		this.date_end = object.meta_box.settings.date_end || null;
		this.excerpt = object.meta_box.content.short_content || null;
		this.content = object.meta_box.content.content || null;
		this.info = object.meta_box.credits.info || [];
		
		// Images
		this.image = object.meta_box.content.image || null;
		this.gallery = object.meta_box.content.gallery || [];
		this.videos = object.meta_box.content.videos || [];
		this.videosLinks = object.meta_box.content.videos_links || [];

		// Design
		this.color = object.meta_box.settings.main_color || null;
		this.textColor = object.meta_box.settings.text_color || null;
		
		// Relations
		this.partners = object.meta_box.credits.partners || null;
		this.news = object.meta_box.news_to_exhibitions_from || [];
		this.products = object.meta_box.exhibitions_to_products_to || [];
		this.documents = object.meta_box.exhibitions_to_documents_to || [];
	}
}


// WEBPACK FOOTER //
// ./src/data/classes/exhibition.class.js